export default [
  {
    path: '/yiyuanjieshao',
    name: 'yiyuanjieshao',
    meta: { title: '医院概况' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/hospital/yiyuanjieshao')
  },
  {
    path: '/tMap',
    name: 'tMap',
    meta: { title: '导航' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/hospital/tMap')
  },
  {
    path: '/dynamicInfo',
    name: 'dynamicInfo',
    meta: { title: '常见问题详情' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/dynamic/dynamicInfo')
  },
  {
    path: '/dynamic',
    name: 'dynamic',
    meta: { title: '常见问题' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/dynamic/dynamic')
  },
  {
    path: '/keshijieshao',
    name: 'keshijieshao',
    meta: { title: '科室介绍' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/hospital/keshijieshao')
  },
  {
    path: '/yishengjieshao',
    name: 'yishengjieshao',
    meta: { title: '医生介绍' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/hospital/yishengjieshao')
  },
  {
    path: '/yishengDetails',
    name: 'yishengDetails',
    meta: { title: '医生介绍详情' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/hospital/yishengDetails')
  },
  {
    path: '/patientLiuyan',
    name: 'patientLiuyan',
    meta: { title: '患者留言' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/hospital/patientLiuyan')
  },
  {
    path: '/healthy',
    name: 'healthy',
    meta: { title: '健康头条' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/hospital/healthy')
  },
  {
    path: '/healthyDetails',
    name: 'healthyDetails',
    meta: { title: '健康头条详情' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/hospital/healthyDetails')
  },
  {
    path: '/feedback',
    name: 'feedback',
    meta: { title: '意见反馈' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/hospital/feedback')
  },
  {
    path: '/moduleSetting',
    name: 'moduleSetting',
    meta: { title: '切换模式' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/user/moduleSetting.vue')
  },
  {
    path: '/eInvoice',
    name: 'eInvoice',
    meta: { title: '电子票据' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/user/eInvoice.vue')
  },
  {
    path: '/eInvoiceDetail',
    name: 'eInvoiceDetail',
    meta: { title: '电子票据' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/user/eInvoiceDetail.vue')
  },
  {
    path: '/careMode',
    name: 'careMode',
    meta: { title: '挂号选择' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/careMode/index.vue')
  },
  {
    path: '/departments',
    name: 'departments',
    meta: { title: '科室选择' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/careMode/departments.vue')
  },
  {
    path: '/registration',
    name: 'registration',
    meta: { title: '预约挂号' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/careMode/registration.vue')
  },
  {
    path: '/registrationTime',
    name: 'registrationTime',
    meta: { title: '选择挂号时间' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/careMode/registrationTime.vue')
  },
  {
    path: '/persons',
    name: 'persons',
    meta: { title: '选择就诊人' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/careMode/persons.vue')
  },
  {
    path: '/registrationSubmit',
    name: 'registrationSubmit',
    meta: { title: '挂号确认' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/careMode/registrationSubmit.vue')
  },
  {
    path: '/registrationSuccess',
    name: 'registrationSuccess',
    meta: { title: '挂号详情' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/careMode/registrationSuccess.vue')
  },
  {
    path: '/doctor',
    name: 'doctor',
    meta: { title: '医生选择' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/careMode/doctor.vue')
  },
  {
    path: '/selectRegistration',
    name: 'selectRegistration',
    meta: { title: '请选择' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/careMode/selectRegistration.vue')
  },
  {
    path: '/registrationByDoctor',
    name: 'registrationByDoctor',
    meta: { title: '选择号源' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/careMode/registrationByDoctor.vue')
  }
]
